export default function () {
  return {
    color: [{
      type: 'linear',
      x: 0,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [{
        offset: 0.1, color: '#f6db84' // 10% 处的颜色
      }, {
        offset: 1, color: '#ffc351' // 100% 处的颜色
      }],
      global: false // 缺省为 false
    }, '#F0F2F5'],
    tooltip: {
      trigger: 'item'
    },
    series: [
      {
        type: 'pie',
        radius: ['60%', '90%'],
        labelLine: {
          show: false
        },
        label: {
          show: false,
          position: 'center'
        },
        itemStyle: {
          borderColor: '#fff',
          borderWidth: 5
        },
        data: [
          {value: 28, name: '已完成'},
          {
            value: 72, name: '未完成',
            emphasis: {
              itemStyle: {
                color: '#f3f3f3',   //hover时改变柱子颜色
              }
            }
          },
        ]
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/mixins/pieData.js